var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6 22.14-2.24-1.33c-.17-.1-.55-.1-.72 0L9.4 22.14c-1.42.84-2.28.49-2.66.21-.38-.28-.98-1-.61-2.6l.53-2.31c.04-.18-.06-.52-.19-.66l-1.86-1.86c-1-1-.92-1.87-.78-2.31.14-.44.58-1.19 1.97-1.43l2.39-.4c.17-.03.44-.23.51-.38l1.32-2.64c.65-1.29 1.51-1.49 1.97-1.49.46 0 1.32.19 1.97 1.49l1.32 2.64c.08.15.35.35.51.38l2.39.4c1.39.23 1.83.99 1.97 1.43.14.44.22 1.31-.78 2.31l-1.86 1.86c-.13.13-.23.48-.19.66l.53 2.3c.37 1.61-.22 2.32-.61 2.6-.18.16-.52.33-1 .33-.43 0-.97-.13-1.64-.53zm-1.48-2.62 2.24 1.33c.59.35.94.35 1.01.29.08-.06.18-.39.03-1.05l-.53-2.3c-.16-.68.1-1.56.59-2.05l1.86-1.86c.37-.37.45-.66.41-.79-.04-.13-.27-.32-.79-.4l-2.39-.4c-.64-.11-1.32-.61-1.61-1.19l-1.32-2.64c-.23-.45-.48-.66-.63-.66-.15 0-.4.2-.63.66l-1.32 2.64c-.29.58-.97 1.08-1.61 1.19l-2.39.4c-.52.09-.75.27-.79.4-.04.13.04.42.41.79l1.86 1.86c.49.49.75 1.38.59 2.05l-.53 2.31c-.15.67-.05 1 .03 1.05.08.06.43.06 1.01-.29l2.24-1.33c.34-.19.74-.29 1.14-.29.4 0 .8.09 1.12.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9V2c0-.41.34-.75.75-.75s.75.34.75.75v7c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM17.25 9V2c0-.41.34-.75.75-.75s.75.34.75.75v7c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM11.25 4V2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRanking);
export default __webpack_public_path__ + "static/media/vuesax-outline-ranking.0dbe5b7ad2445fa04c9f9462457c83d3.svg";
export { ForwardRef as ReactComponent };